import { Inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { IHttpClientService } from '../../../interfaces/index';
import { GetConfig } from 'src/app/library-modules/auth-config.module';

@Injectable()
export class GetTokenUseCase {
    constructor(@Inject('IHttpClientService') private httpService: IHttpClientService) { }

    execute(): Observable<string> {
        return this.httpService.get(GetConfig().serviceRootUrl+'/api/Authorization/token', new HttpParams());
    }
}
